import { render, staticRenderFns } from "./IdVerification.vue?vue&type=template&id=4a994394"
import script from "./IdVerification.vue?vue&type=script&lang=js"
export * from "./IdVerification.vue?vue&type=script&lang=js"
import style0 from "./IdVerification.vue?vue&type=style&index=0&id=4a994394&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports